/* global $ toastr */

import { format_datetime } from '../lib/utils'
import React, { Component } from 'react'
import { uploadFile, request, downloadFile } from '../lib/utils'
import { Panel } from '../lib/components'


/**
 * Просмотрщик файла, который поддерживает
 * - Растровые изображения
 * - pdf (через pdf-js)
 * - Офисные документы через сервис OnlyOffice
 * Принимает props
 * - file: Объект
 */
class FileViewer extends Component {

  render() {
    const file = this.props.file
    let show_container;

    if (file.view_mode === "img") {
      show_container = <img src={file.url} style={{ maxWidth: "100%" }}></img>
    }

    else if (file.view_mode === "pdf") {
      show_container = <iframe src={file.url} height="800" width="100%" />
    }

    // TODO: Нужно сделать
    // else if (file.view_mode === "office") {
    //     show_container = <img src={file.url} style={{ maxWidth: "100%" }}></img>
    // }

    else {
      show_container = <div>Просмотр недоступен для файла {file.view_mode}</div>
    }

    return <div>
      {show_container}
      <div>
        <div>Дата загрузки: {format_datetime(file.d_create)}</div>
        <div>Название файла: {file.file_name}</div>
      </div>
    </div>
  }
}

/**
 * Отображение файлов
 * props:
 * - project_name
 * - object_id
 * - files_schema
 * - files
 */
export class FileListBlock extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showTypes: [],
      file_show_info_id: undefined,
      selectedFiles: []
    }

    this.ref_upload_file = React.createRef();
    this.uploadHandler = this.uploadHandler.bind(this);
    this.getFilesByType = this.getFilesByType.bind(this);
    this.renderSchemaItem = this.renderSchemaItem.bind(this);
    this.toggleFilesInType = this.toggleFilesInType.bind(this);
    this.renderFile = this.renderFile.bind(this);
  }

  // Фильтрует из всех файлов с нужным типом и возвращает список из них
  getFilesByType(filetype, files) {
    return (files ?? this.props.files)?.filter(v => v.file_type === filetype)
  }

  downloadFiles(...items) {
    if (items.length === 0) {
      return toastr.warning('Не выбрано ни одного файла для скачивания. Отметьте хотя бы один')
    }

    request({
      method: 'GET',
      url: `/api/${this.props.project_name}/${this.props.object_id}/download_files?${items.map((item) => `files_ids=${item.id}`).join('&')}`,
      responseType: "file",
      success: (data) => {
        downloadFile(data.content, data.filename)
      },
    })
  }

  // Переключаем отображение файлов в типе
  toggleFilesInType(filetype) {
    const showTypes = this.state.showTypes
    let showTypesNew = [...showTypes]
    const index = showTypesNew.indexOf(filetype)

    if (index === -1) {
      showTypesNew.push(filetype)
    }
    else {
      showTypesNew.splice(index, 1)
    }

    this.setState({ ...this.state, showTypes: showTypesNew })
  }

  // Отрисовать модальное окно для отображения файла
  renderShowModal() {
    // Файл не выбран
    if (this.state === null || this.state.selected_file === undefined) {
      return null;
    }

    const file = this.state.selected_file;

    return (
      <div className="modal fade" id="modal_file" tabIndex="-1" style={{ display: "none" }} aria-hidden="true">
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel1">{file.file_name}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <FileViewer file={file} />
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary p-2 me-1" data-bs-dismiss="modal">
                <i className="ti ti-square-rounded-x me-1" />
                Закрыть
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  uploadHandler(file_type) {
    const that = this;
    const input = this.ref_upload_file.current

    function filesSelected() {
      Array.from(input.files).forEach(file_item => {
        uploadFile({
          file_item: file_item,
          url: `/api/${that.props.project_name}/${that.props.object_id}/upload_file`,
          form_args: { file_type: file_type },
          callback: (data) => { that.props.fileUploaded(data) }
        })
      })
    }

    input.addEventListener('change', filesSelected, { once: true })
    input.click()
  }

  renderSchemaItem(item) {
    const that = this

    // Заголовок (если filetype нет)
    if (item.filetype === undefined) {
      let file_list = []
      let selectedFileList = []
      
      for (let i = this.props.files_schema.findIndex((v) => {return v.title === item.title}); i < this.props.files_schema.length; i++) {
        file_list = [...file_list, ...this.getFilesByType(this.props.files_schema[i].filetype)]
        selectedFileList = [...selectedFileList, ...this.getFilesByType(this.props.files_schema[i].filetype, this.state.selectedFiles)]
        if (this.props.files_schema[i].title !== item.title && this.props.files_schema[i].filetype === undefined) {
          break
        }
      }

      const selected = selectedFileList.length === file_list.length
 
      return (
        <li className="list-group-item p-1 px-3" key={item.title}>
          <div className="d-flex justify-content-between">
            <strong>{item.title}</strong>
            { file_list.length > 0 &&
              <i className={`ti ti-${selected ? 'square-check' : 'square'} me-1 pointer`} onClick={() => {
                  const selectedFilesIds = selectedFileList.map((v) => v.id)
                  this.setState({...this.state, selectedFiles: selected ? this.state.selectedFiles.filter((v) => !selectedFilesIds.includes(v.id)) : [...file_list.filter((v) => !selectedFilesIds.includes(v.id)), ...this.state.selectedFiles]})
                }
              } />
            }
          </div>
        </li>
      )
    }

    const file_list = this.getFilesByType(item.filetype)
    const selectedFileList = this.getFilesByType(item.filetype, this.state.selectedFiles)
    const selected = selectedFileList.length === file_list.length
    const files_show = that.state.showTypes.includes(item.filetype)

    return (
      <li className="list-group-item p-1 px-3" key={item.title}>
        <div className="d-flex justify-content-between">
          <div className="flex-grow-1 pointer" onClick={() => { this.toggleFilesInType(item.filetype) }}>{item.title}</div>
          <div className="me-1" >
            { file_list.length > 0 &&
              <i className={`ti ti-${selected ? 'square-check' : 'square'} me-1 pointer`} onClick={() => {
                  const selectedFilesIds = selectedFileList.map((v) => v.id)
                  this.setState({...this.state, selectedFiles: selected ? this.state.selectedFiles.filter((v) => !selectedFilesIds.includes(v.id)) : [...file_list.filter((v) => !selectedFilesIds.includes(v.id)), ...this.state.selectedFiles]})
                }
              } />
            }
            <i className='ti ti-cloud-upload pointer' onClick={() => { that.uploadHandler(item.filetype) }}/>
          </div>
          <span className="badge bg-secondary rounded-pill px-2">{file_list.length}</span>
        </div>
        {files_show && <div className="d-flex flex-wrap">
          {file_list.map(this.renderFile)}
        </div>}
      </li>
    )
  }

  renderFile(item) {
    const that = this
    const selected = this.state.selectedFiles.filter((v) => v.id === item.id).length > 0
    const file_show_info_id = this.state.file_show_info_id

    function renderFileContent(item) {
      if(file_show_info_id == item.id) {
        return <div style={{fontSize: "0.9em"}}>
          <div>{format_datetime(item.d_create)}</div>
          <div>{that.props.getChoice("User", item.author_id)}</div>
          <div>{item.file_name}</div>
        </div>
      }

      if(item.thumbnail.includes("dummy")) {
        return <span className="ti ti-file" style={{fontSize: "110px"}}></span>
      }

      return <img src={"/media/" + item.thumbnail} className="rounded" style={{ width: "110px", height: "110px", }}></img>
    }

    return (
      <div key={item.id} className="border me-1 mb-1 p-1">
        <div style={{ width: "110px", height: "110px", textAlign: "center" }}>
          {renderFileContent(item)}
        </div>
        <i className="ti ti-info-circle pointer" key="info" onClick={() => {
          that.setState({ ...this.state, file_show_info_id: file_show_info_id == item.id ? undefined : item.id})
        }} />
        <i className="ti ti-download pointer" key="download" onClick={() => { that.downloadFiles(item) }} />
        <i className="ti ti-photo-search pointer" key="search" onClick={() => {
          that.setState({ ...this.state, selected_file: item }, () => {
            $("#modal_file").modal("show")
          })
        }} />
        <i className={`ti ti-${selected ? 'square-check' : 'square'} me-2 pointer`}
          onClick={() => this.setState(
          {...this.state, selectedFiles: selected ? [...this.state.selectedFiles.filter((v) => v.id !== item.id)] : [...this.state.selectedFiles, item]}
        )}/>
      </div>
    )
  }

  render() {
    const selected = this.state.selectedFiles.length === this.props.files.length

    return (
      <Panel header="Файлы" key="files" noWrapBody={true}>
        <div className='d-flex mx-3 justify-content-between'>
            { this.props.files.length > 0 && 
              <div className='pointer' style={{userSelect: 'none'}} onClick={() => this.setState(
                {...this.state, selectedFiles: !selected ? this.props.files : []}
              )}>
                <i className={`ti ti-${selected ? 'square-check' : 'square'} me-2`} />
                <span>Выбрать все</span>
              </div>
            }
        </div>
        <ul className="list-group list-group-flush">
          {this.props.files_schema.map(this.renderSchemaItem)}
        </ul>
        {this.renderShowModal()}
        <div style={{ display: "none" }}>
          <input id="file-input" type="file" multiple="multiple" ref={this.ref_upload_file}></input>
        </div>
        <div className='border-top' />
        <div className='d-flex mt-2 mb-2 mx-3 justify-content-between'>
          { this.props.files.length > 0 &&
            <i className='ti ti-download text-primary pointer' onClick={() => this.downloadFiles(
              ...(this.state.selectedFiles.length > 0 ? this.state.selectedFiles : this.props.files)
            )}/>
          }
        </div>
      </Panel>
    )
  }
}